import {
  createSlice,
  createEntityAdapter,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import {
  createCategory,
  updateCategory,
  deleteCategory,
  getCategories,
} from "data/server_apis/commodityService";
const categoryAdapter = createEntityAdapter({
  selectId: (category) => category.id,
});
export const createCategoryThunk = createAsyncThunk(
  "product_category/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createCategory(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getCategoriesThunk = createAsyncThunk(
  "product_category/getCategories",
  async (_, { rejectWithValue }) => {
    try {
      return (await getCategories()).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const deleteCategoriesThunk = createAsyncThunk(
  "product_category/deleteCategories",
  async (id, { rejectWithValue }) => {
    try {
      return (await deleteCategory(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updateCategoryThunk = createAsyncThunk(
  "product_category/updateCategory",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateCategory(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const categorySlice = createSlice({
  name: "product_category",
  initialState: categoryAdapter.getInitialState({
    loading: {},
    error: {},
    errorMessage: {},
    success: {},
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCategoryThunk.pending, (state, action) => {
        state.loading = { create: true };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(createCategoryThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { create: true };
        state.success = {};
        state.errorMessage = { create: action.payload?.message };
      })
      .addCase(createCategoryThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { create: true };
        state.errorMessage = {};
        categoryAdapter.addOne(state, action.payload);
      });

    builder
      .addCase(getCategoriesThunk.pending, (state, action) => {
        state.loading = { list: true };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(getCategoriesThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { list: true };
        state.success = {};
        state.errorMessage = { list: action.payload?.message };
      })
      .addCase(getCategoriesThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { list: true };
        state.errorMessage = {};
        categoryAdapter.setAll(state, action.payload);
      });

    builder
      .addCase(deleteCategoriesThunk.pending, (state, action) => {
        state.loading = { delete: action.meta.arg };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(deleteCategoriesThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { delete: true };
        state.success = {};
        state.errorMessage = { delete: action.payload?.message };
      })
      .addCase(deleteCategoriesThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { delete: true };
        state.errorMessage = {};
        categoryAdapter.removeOne(state, action.meta.arg);
      });

    builder
      .addCase(updateCategoryThunk.pending, (state, action) => {
        state.loading = { update: action.meta.arg.id };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(updateCategoryThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { update: action.meta.arg.id };
        state.success = {};
        state.errorMessage = { update: { id: action.payload?.message } };
      })
      .addCase(updateCategoryThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { update: action.meta.arg.id };
        state.errorMessage = {};
        categoryAdapter.updateOne(state, {
          id: action.meta.arg.id,
          changes: action.payload,
        });
      });
  },
});
export const categorySelector = categoryAdapter.getSelectors(
  (state) => state.category
);

export const {} = categorySlice.actions;

export default categorySlice.reducer;
